import { ConsolidatedActions } from "../actions";

const initialState = {
  approvedSimulation: null,
  approvedSimulationLoading: true,

  simulation: null,
  simulationLoading: true,

  client: null,
  clientLoading: true,

  access: null,
  accessLoading: true,

  contract: null,
  contractLoading: true,

  hash: null,
  hashLoading: true,

  totalContracts: null,
  totalContractsLoading: true,

  insuranceContracts: null,
  insuranceContractsLoading: true,
};

export default function consolidated(state = initialState, action) {
  switch (action.type) {
    case ConsolidatedActions.ACTION_LOADING_APPROVED_SIMULATION:
      return {
        ...state,
        approvedSimulationLoading: action.payload,
      };

    case ConsolidatedActions.ACTION_SAVE_APPROVED_SIMULATION:
      return {
        ...state,
        approvedSimulation: action.payload,
      };

    case ConsolidatedActions.ACTION_SAVE_SIMULATION:
      return {
        ...state,
        simulation: action.payload,
      };

    case ConsolidatedActions.ACTION_LOADING_SIMULATION:
      return {
        ...state,
        simulationLoading: action.payload,
      };

    case ConsolidatedActions.ACTION_SAVE_CLIENT:
      return {
        ...state,
        client: action.payload,
      };

    case ConsolidatedActions.ACTION_LOADING_CLIENT:
      return {
        ...state,
        clientLoading: action.payload,
      };

    case ConsolidatedActions.ACTION_SAVE_ACCESS:
      return {
        ...state,
        access: action.payload,
      };

    case ConsolidatedActions.ACTION_LOADING_SAVE_ACCESS:
      return {
        ...state,
        accessLoading: action.payload,
      };

    case ConsolidatedActions.ACTION_SAVE_CONTRACT:
      return {
        ...state,
        contract: action.payload,
      };

    case ConsolidatedActions.ACTION_LOADING_SAVE_CONTRACT:
      return {
        ...state,
        contractLoading: action.payload,
      };

    case ConsolidatedActions.ACTION_SAVE_HASH:
      return {
        ...state,
        hash: action.payload,
      };

    case ConsolidatedActions.ACTION_LOADING_SAVE_HASH:
      return {
        ...state,
        hashLoading: action.payload,
      };

    case ConsolidatedActions.ACTION_SAVE_TOTAL_CONTRACTS_DATA:
      return {
        ...state,
        totalContracts: action.payload,
      };

    case ConsolidatedActions.ACTION_LOADING_TOTAL_CONTRACTS:
      return {
        ...state,
        totalContractsLoading: action.payload,
      };

    case ConsolidatedActions.ACTION_SAVE_INSURANCE_CONTRACTS_DATA:
      return {
        ...state,
        insuranceContracts: action.payload,
      };

    case ConsolidatedActions.ACTION_LOADING_INSURANCE_CONTRACTS:
      return {
        ...state,
        insuranceContractsLoading: action.payload,
      };

    default:
      return state;
  }
}

export function getAccess(state) {
  return state.consolidated.access;
}

export function getAccessLoading(state) {
  return state.consolidated.accessLoading;
}

export function getApprovedSimulation(state) {
  return state.consolidated.approvedSimulation;
}

export function getSimulation(state) {
  return state.consolidated.simulation;
}

export function getLoadingApprovedSimulation(state) {
  return state.consolidated.approvedSimulationLoading;
}

export function getLoadingSimulation(state) {
  return state.consolidated.simulationLoading;
}

export function getClient(state) {
  return state.consolidated.client;
}

export function getLoadingClient(state) {
  return state.consolidated.clientLoading;
}

export function getContract(state) {
  return state.consolidated.contract;
}

export function getContractLoading(state) {
  return state.consolidated.contractLoading;
}

export function getHash(state) {
  return state.consolidated.hash;
}

export function getHashLoading(state) {
  return state.consolidated.hashLoading;
}

export function getTotalContracts(state) {
  return state.consolidated.totalContracts;
}

export function getTotalContractsLoading(state) {
  return state.consolidated.totalContractsLoading;
}

export function getInsuranceContracts(state) {
  return state.consolidated.insuranceContracts;
}

export function getInsuranceContractsLoading(state) {
  return state.consolidated.insuranceContractsLoading;
}
